import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BehaviorSubject } from 'rxjs';
import { DetailToolbarComponent } from 'src/app/shared/detail-toolbar.component';

@Component({
    selector: 'app-wizard-step',
    templateUrl: './wizard-step.component.html',
    styleUrls: ['./wizard-step.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressBarModule, DetailToolbarComponent, MatLegacyButtonModule, MatIconModule, AsyncPipe]
})
export class WizardStepComponent {
    readonly title = input<string>(undefined);
    readonly stepIndex = input(1);
    readonly lastStepIndex = input(5);
    readonly stepSubTitle = input<string>(undefined);
    readonly nextButtonText = input('Next');
    readonly nextButton2Text = input('SEND TO CANDIDATE');
    readonly isLoading = input(new BehaviorSubject<boolean>(true));
    readonly isNextButton2Enabled = input(false);
    @Output() previousStepClicked = new EventEmitter();
    @Output() nextStepClicked = new EventEmitter();
    @Output() nextStep2Clicked = new EventEmitter();

    goToPreviousStep(): void {
        this.previousStepClicked.emit();
    }

    goToNextStep(): void {
        this.nextStepClicked.emit();
    }

    goToNextStep2(): void {
        this.nextStep2Clicked.emit();
    }
}
